import $ from 'jquery';
import AjaxRequest from "../modules/ajax-request";
import Cookies from "js-cookie";

class AccountComplete {
    constructor(element) {
        this._div = element;
        this._urlAction = $(this._div).data('action');
        this.init();
    }
    init() {
        if (parseInt(Cookies.get("cs_logged")) === 1) {
            this.renderModal();
        }
    }
    renderModal() {
        let _this = this;
        let _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_this._div).find("[data-modal-wrapper]").html(response.modalHtml);
            }
        });

        _ajaxRequest.makeCall(this._urlAction);
    }
}

export default AccountComplete;
